import React, { useEffect } from 'react';
import clarity from '@microsoft/clarity';
import StashrLogo from './images/stashr-landing-logo-v2.png';
import { ReactComponent as WhiteLogo } from './images/stashr-white-logo.svg';
import Terms from './components/Terms';
import Privacy from './components/Privacy';

import LandingPage from './components/LandingPage';
import StreamlinedSimulation from './components/SimulationV2';
import StashrMCPChat from './components/MCPLanding';
import SharedResult from './components/SharedResult';
import Installer from './components/Installer';
import { NavigationProvider, useNavigation } from './context/NavigationContext';

const Navigation: React.FC = () => {
  const { navigate } = useNavigation();

  return (
    <div className="nav">
      <div className="nav-container">
        <div className="nav-left">
          <div className="nav-item" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src={StashrLogo} className="nav-logo" alt="Stashr logo in black text with white background" />
          </div>
        </div>
        <div className="nav-right">
          <Installer
            text="Install Stashr" className="nav-item"
          />
        </div>
      </div>
    </div>
  )
}

const Footer: React.FC = () => {
  const { navigate } = useNavigation();

  return (
    <div className="footer">
      <div className="footer-top-container">
        <div className="footer-left">
          <div
            className="nav-item"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
            aria-label="Navigate to Stashr homepage"
          >
            <WhiteLogo />
          </div>
          <h3 className="footer-subtext white-color">
            Never miss an opportunity to maximize your credit card rewards
          </h3>
          <Installer
            text="Install Stashr"
            className="footer-button"
            align="left"
          />
        </div>

        <div className="footer-right">
          <div className="footer-right-text-container">
            <p className="white-color font-size-1">
              Contact
            </p>

              <a href="mailto:hello@stashr.ai" className="white-color">
                hello@stashr.ai
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom-wrapper">
          <div className="footer-bottom-container">
            <p className="white-color font-size-1">
              © {new Date().getFullYear()} Stashr
            </p>
            <div className="footer-policy-links">
              <div onClick={() => navigate('/privacy')} className="white-color font-size-1" style={{ cursor: 'pointer' }}>
                Patent Pending
              </div>
              <div onClick={() => navigate('/privacy')} className="white-color font-size-1" style={{ cursor: 'pointer' }}>
                Privacy Policy
              </div>
              <div onClick={() => navigate('/terms')} className="white-color font-size-1" style={{ cursor: 'pointer' }}>
                Terms of Service
              </div>
            </div>
          </div>
        </div>
        </div>
  )
}

const AppContent: React.FC = () => {
  const { pathname } = useNavigation();

  // API URL uses same host but with /api path prefix
  const apiUrl = window.location.origin;

  const renderContent = () => {
    switch (true) {
      case pathname === '/terms':
        return <Terms />;
      case pathname === '/privacy':
        return <Privacy />;
      case pathname === '/simulation':
        return <StreamlinedSimulation apiUrl={apiUrl} />;
      case pathname === "/mcp":
        return <StashrMCPChat />;
      case pathname.startsWith('/share/'):
        const publicId = pathname.substring(7); // Remove '/share/' prefix
        return <SharedResult apiUrl={apiUrl} publicId={publicId} />;
      default:
        return <LandingPage />;
    }
  };

  return (
    <>
      <Navigation />
      <main style={{ flex: 1 }}>
        <div className="landing-container">
          {renderContent()}
        </div>
      </main>
      <Footer />
    </>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize Microsoft Clarity only in production
    const clarityId = process.env.CLARITY_PROJECT_ID;
    if (clarityId) {
      clarity.init(clarityId);
    }
  }, []);

  return (
    <NavigationProvider>
      <AppContent />
    </NavigationProvider>
  );
};

export default App;
